export const ApiLocalStorage = (field, value) => {
	const {localStorage} = window;
	if (value) {
		localStorage.setItem(field, JSON.stringify(value));
		return;
	}
	return JSON.parse(localStorage.getItem(field));
}
